import React, { Fragment, createContext, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import LoginSignUp from './pages/LoginSignUp';
import PurchaseVerify from './pages/PurchaseVerify';
import TermsAndConditions from './pages/TermsAndConditions';
import FAQs from './pages/FAQs';
import ChooseProduct from './pages/ChooseProduct';
import ContactUs from './pages/ContactUs';
import Cart from './pages/Cart';
import CheckOut from './pages/CheckOut';
import Designer from './pages/Designer';
import SecondDesigner from './pages/SecondDesigner';
import UserDashboard from './pages/UserDashboard';
import Footer from "./components/Footer"
import NavBar from "./components/NavBar"
import ProductDetail from './pages/ProductDetail';
import Products from './pages/Products';
import PuzzleProducts from './pages/PuzzleProducts';
import AdminProducts from './pages/admin/AdminProducts';
import Commendation from './components/Commendation';
import { Initilization } from './components/Initilization';
import {ScrollToTop} from './components/ScrollToTop';
import { NotificationProvider } from './components/NotificationContext';
import { ConfigProvider } from 'antd';

export const MyContext = createContext();

const App = () => {

  const [firstDesignBase64, setFirstDesignBase64] = useState('');
  const [firstDesignAdditionalPics, setFirstDesignAdditionalPics] = useState([]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#a23854',
          borderRadius: 8,


        },
      }}
    >
      <NotificationProvider>
        <Initilization />

        <MyContext.Provider value={{ firstDesignBase64, setFirstDesignBase64, firstDesignAdditionalPics, setFirstDesignAdditionalPics }}>
          <Router>
          <ScrollToTop />
            <NavBar />
            {/* <Initilization/>  */}
            <div style={{ minHeight: "50vh" }} className='mt-4 mb-5 mr-3 ml-3'>
              <Routes>

                <Route path="/" element={<Home />} />
                <Route path="/user-dashboard" element={<UserDashboard />} />
                <Route path="/choose-product" element={<ChooseProduct />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/products" element={<Products />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<CheckOut />} />
                <Route path="/designer/:ProductType" element={<Designer />} />
                <Route path="/second-designer/:ProductType" element={<SecondDesigner />} />
                <Route path="/login-signup/:CallBackUrl?" element={<LoginSignUp />} />
                <Route path="/purchase-verify" element={<PurchaseVerify />} />
                <Route path="/puzzle-products" element={<PuzzleProducts />} />
                {/* Fallback route for 404 Not Found */}  .
                <Route path="*" element={<h1>404 Not Found</h1>} />
              </Routes>
            </div>
            <Commendation />
            <Footer />


          </Router>
        </MyContext.Provider>
      </NotificationProvider>
    </ConfigProvider>
  );
};

export default App;  